export default __webpack_public_path__ + "static/media/confirmX.257dd901.svg";